import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/OvernightManagement/GetGroupWithPaging",
    method: "get",
    params
  });
}
export function confirm(data) {
  return request({
    url: "/OvernightManagement/Read",
    method: "post",
    data
  });
}
